// Keys for localStorage
export const PERMISSION_ASKED_STORAGE_KEY = 'push-notifications-permission-asked';
export const REJECT_NOTIFICATIONS_STORAGE_KEY = 'push-notifications-rejected';
export const NOTIFICATIONS_SUBSCRIPTION_ID = 'push-notifications-subscription-id';

// number of times we can ask for permission
export const MAX_ASK_PERMISSION = 1;

// forget the times when we asked permission that are older that this
export const MAX_TIME_PERMISSION_ASKED = 30 * 24 * 60 * 60 * 1000;

// wait at least this much to ask permission again
export const MIN_TIME_BETWEEN_ASK = 7 * 24 * 60 * 60 * 1000;
